import {Divider, Stack, Text} from "@mantine/core";
import RatesForApprovalTable from "../../components/project/Table.RatesForApproval/Table.RatesForApproval";
import useUserStore from "../../data/User.store";
import {useRates} from "../../api/Rates/Rates.hooks";
import {useState} from "react";
import RatesFiltersManager from "../../components/project/Rates.filters/Rates.filters.manager";
import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import RatesFilters from "../../components/project/Rates.filters/Rates.filters";
import RateApi from "../../api/Rates/Rates.api";


function RatesForApproval() {
    const [query, setQuery] = useState(getLocalStorageQuery());
    const {user} = useUserStore();
    const {data, isLoading, refetch} = useRates(query);

    function onSubmitQuery(values: any) {
        let serializedQuery = RatesFiltersManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .setInitialQuerySent()
            .getValues();
        setQuery(serializedQuery);
    }

    function getLocalStorageQuery() {
        return RatesFiltersManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getRateFiltersInitialValues() {
        return RatesFiltersManager
            .setSerializedValues(
                RatesFiltersManager
                    .getQueryFromLocalStorage()
                    .getValues()
            )
            .deserializeQuery()
            .getValues()
    }

    async function onClickStatus(contractId:string, approved:true|false){
        await RateApi.changeRateStatus(contractId, approved);
        await refetch();
    }


    function renderTable() {
        if (isLoading) {
            return <LoaderDefault text="Loading rates for approval..."/>
        } else if (!data) {
            return <Text color="white">No data loaded for current query.</Text>
        } else {
            return <RatesForApprovalTable data={data} onClickStatus={onClickStatus}/>;
        }
    }

    return (
        <Stack>
            <RatesFilters onSubmitQuery={onSubmitQuery} initialValues={getRateFiltersInitialValues()} user={user}/>
            <Divider variant="dashed"/>
            {renderTable()}
        </Stack>
    )
}

export default RatesForApproval;